import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractRadioInput} from "../abstract-radio-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineRadioInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-radio-input",
    styleUrls: ["./inline-radio-input.component.scss"],
    templateUrl: "./inline-radio-input.component.html"
})
export class FUIInlineRadioInputComponent extends FUIAbstractRadioInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
